export const isOfferSurveyDone = offerNumber => {
  try {
    const offerProcessed = localStorage.getItem('PennyCaresSurveyDict');
    const parsedOfferProcessed = JSON.parse(offerProcessed);
    return parsedOfferProcessed.includes(offerNumber);
  } catch (e) {
    /* There doesn’t seem to be a need to log to Splunk in this case.
         Essentially, if parsing fails—perhaps because the user has modified values in localStorage—we simply return false.
         This allows the user to refill the survey. However, the SURVEY_API will throw an error,
         ensuring the correct value is stored in localStorage to prevent the user from resubmitting. */
    return false;
  }
};